import React, { createContext, useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useStore } from 'Store/index';
import { EPG_LIST_TYPES } from '../../../options';

export const FavoriteChannelsProvider = ({ children }) => {
    const { appManager } = useStore();
    const [favoriteChannels, setStateFavoriteChannels] = useState([]);
    const [loading, setLoading] = useState(false);

    const setFavoriteChannels = useCallback(
        async (useCache = true) => {
            if (loading) return;
            setLoading(true);
            try {
                const { items } = await appManager.getApi().fetchChannelsBrief(
                    {
                        list: EPG_LIST_TYPES.FAVORITES
                    },
                    true,
                    useCache
                );
                setStateFavoriteChannels(items);
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        },
        [setStateFavoriteChannels]
    );

    return (
        <FavoriteChannelsContext.Provider
            value={{
                favoriteChannels,
                setFavoriteChannels
            }}
        >
            {children}
        </FavoriteChannelsContext.Provider>
    );
};

FavoriteChannelsProvider.defaultProps = {
    children: []
};

FavoriteChannelsProvider.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

const FavoriteChannelsContext = createContext({});

export const useFavoriteChannelsContext = () => useContext(FavoriteChannelsContext);

export const withFavoriteChannelsContext = (Component) => (props) => (
    <FavoriteChannelsContext.Consumer>
        {(context) => <Component {...props} {...context} />}
    </FavoriteChannelsContext.Consumer>
);
